var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('keep-alive',[_c('router-view')],1)],1),_c('v-footer',{attrs:{"app":"","fixed":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"text-caption"},[_vm._v("Sphere Kiosk Configurator v"+_vm._s(_vm.version))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }